import { lazy } from 'react';

const CharityVettingOrganisationTypeRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "OrganisationType" */ '../components/steps/organisation-type-step/OrganisationType'
    ),
);

export default CharityVettingOrganisationTypeRoute;
